
import { Vue, Component, Prop } from 'vue-property-decorator';
import T from '../../lang';
import user_Username from '../user/Username.vue';
import { types } from '../../api_types';
import { getBlogUrl } from '../../urlHelper';

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
library.add(faInfoCircle);

@Component({
  components: {
    FontAwesomeIcon,
    'omegaup-user-username': user_Username,
  },
})
export default class CoderOfTheMonth extends Vue {
  @Prop({ default: 'all' }) category!: string;
  @Prop() coderOfTheMonth!: types.UserProfile;

  T = T;
  get CoderOfTheMonthPolicyURL(): string {
    return getBlogUrl('CoderOfTheMonthPolicyURL');
  }
}
